<template>
  <div
    class="fts-event-toggle"
    @click="open"
    @mouseenter="expand = true"
    @mouseleave="expand = false"
  >
    <font-awesome-icon
      :icon="['far', 'envelope']"
      fixed-width
      v-if="isNotification"
    />
    <font-awesome-icon
      :icon="['fas', 'bolt']"
      fixed-width
      v-else
    />
    <span class="event-toggle-count" v-if="count">{{count}}</span>
    <transition name="event-fade">
      <div class="event-toggle-overlay" v-if="expand">
        <fts-btn
          outline
          color="var(--fts-primary)"
          text-transform-init
          class="event-toggle-btn"
        >
          New {{isNotification ? 'Notification' : 'Automation'}}
          <font-awesome-icon
            :icon="['far', 'envelope']"
            fixed-width
            class="event-toggle-btn-icon"
            v-if="isNotification"
          />
          <font-awesome-icon
            :icon="['fas', 'bolt']"
            fixed-width
            class="event-toggle-btn-icon"
            v-else
          />
        </fts-btn>
      </div>
    </transition>
  </div>
</template>

<script>
import FTSBtn from "../../elements/FTSBtn";

export default {
  props: {
    eventType: String,
    count: Number
  },
  components: {
    "fts-btn": FTSBtn
  },
  data: () => ({
    expand: false
  }),
  methods: {
    open() {
      this.$emit('open');
    }
  },
  computed: {
    isNotification() {
      return this.eventType && this.eventType.toLowerCase() === 'notification';
    }
  }
}
</script>

<style lang="scss" scoped>
.fts-event-toggle {
  position: relative;
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  color: var(--fts-default);
  .event-toggle-count {
    margin-left: 0.125rem;
    font-size: 0.75rem;
  }
  .event-toggle-overlay {
    position: absolute;
    right: calc(-0.375rem - 1px);
    white-space: nowrap;
    z-index: 1;
    .event-toggle-btn.fts-btn {
      min-height: 1.5rem;
      height: auto;
      padding-left: 0.5rem;
      padding-right: 0.375rem;
      border-radius: 10em;
      background-color: var(--fts-card-background);
      font-size: 0.75rem;
      .event-toggle-btn-icon {
        margin-left: 0.375rem;
        margin-right: 0;
        font-size: 0.875rem;
      }
    }
  }
  /* transition */
  .event-fade-enter-active, 
  .event-fade-leave-active {
    transition: opacity 0.2s linear;
  }
  .event-fade-enter, 
  .event-fade-leave-to {
    opacity: 0;
  }
}
</style>